import * as React from 'react';

import {useCustomFieldHandlers} from '../../../core-entity/hooks/use-custom-field-handlers';
import type {UpdateCustomField} from '../../../core-entity/hooks/use-custom-field-handlers';

import {useUpdateAccountCustomFieldValue} from '../graphql/hooks/use-update-account-custom-field-value';

export function useAccountCustomFieldHandlers(accountId: string) {
    const {updateAccountCustomFieldValue} = useUpdateAccountCustomFieldValue();

    const updateCustomField = React.useCallback<UpdateCustomField>(
        ({fieldName, value}) =>
            updateAccountCustomFieldValue({
                accountId,
                customFields: [
                    {
                        fieldName,
                        value,
                    },
                ],
            }),
        [accountId, updateAccountCustomFieldValue]
    );

    return useCustomFieldHandlers(updateCustomField);
}
